import 'Plugins/fancyboxPlugin';

// lightbox init
export default function initFancybox() {
	const page = jQuery('body');
	const activeClass = 'fancybox-active';
	const activeClass2 = 'modal-team-member-active';

	jQuery('a.lightbox, [data-fancybox], a[href^="#modal_"]').fancybox({
		parentEl: 'body',
		margin: [50, 0],
		touch: false,
		beforeShow: function(self, opt) {
			if (jQuery(opt.src).hasClass('modal-full-screen')) {
				page.addClass(activeClass);
			}
			if (jQuery(opt.src).hasClass('modal-member')) {
				page.addClass(activeClass2);
			}
		},
		afterShow: function(self) {
			const memberModals = jQuery('.fancybox-container').find('.modal-member');

			if (memberModals.length) {
				const slides = jQuery('.fancybox-container').find('.fancybox-slide');
				const currSlide = slides.filter('.fancybox-slide--current').find('.modal-member');
				const currIndex = self.currIndex;
				const btnPrev = currSlide.find('.btn-prev');
				const btnNext = currSlide.find('.btn-next');
				const prevImage = btnPrev.find('.card-img img');
				const prevName = btnPrev.find('.name');
				const nextImage = btnNext.find('.card-img img');
				const nextName = btnNext.find('.name');
				const prevIndex = currIndex === 0 ? undefined : currIndex - 1;
				const nextIndex = currIndex === self.group.length - 1 ? undefined : currIndex + 1;

				if (nextIndex !== undefined) {
					const nextSlideID = self.group[nextIndex].src;
					const nextSlide = jQuery(nextSlideID);
					const image = nextSlide.find('.card-img img');
					const name = nextSlide.find('.card-title');

					btnNext.show();

					nextImage.attr('src', image.attr('src'));
					nextName.text(name.text());
				} else {
					btnNext.hide();
				}

				if (prevIndex !== undefined) {
					const prevSlideID = self.group[prevIndex].src;
					const prevSlide = jQuery(prevSlideID);
					const image = prevSlide.find('.card-img img');
					const name = prevSlide.find('.card-title');

					btnPrev.show();

					prevImage.attr('src', image.attr('src'));
					prevName.text(name.text());
				} else {
					btnPrev.hide();
				}
			}
		},
		afterClose: function() {
			page.removeClass(activeClass + ' ' + activeClass2);
		}
	});
}